import styled from 'styled-components';

const FullHeightDivWithStyle = styled.div`
  height: 100%;
  position: relative;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
`;

export default FullHeightDivWithStyle;
